import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { WarehouseRestockProductResponse } from './warehouse-restock-product.response';

@jsonObject
export class WarehouseRestockProductCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(WarehouseRestockProductResponse)
  public readonly good!: WarehouseRestockProductResponse;
}
